import Card from "../../../../components/card/card";
import { useAuthorProfile } from "../../../../hooks/use-author-profile";
import { useCurrentUser } from "../../../../hooks/use-current-user";
import { useViewerComments } from "../../../../hooks/use-viewer-comments";
import { colours } from "../../../../styles/colours.constants";
import type { AuthorComment } from "../../../../types/comments.types";
import Comment from "../../../broadcast-portal/modules/chat-module/components/comment/comment";

import * as CSS from "./viewer-comments.styles";

type ViewerCommentsProps = {
	broadcastId: string | null;
	authorId: string | null;
};

const ViewerComments = ({ broadcastId, authorId }: ViewerCommentsProps) => {
	const currentUser = useCurrentUser();
	const comments = useViewerComments(broadcastId, currentUser?.uid ?? null);
	const { name: authorName } = useAuthorProfile(authorId);

	if (!currentUser) {
		return <div>Login to see your comments.</div>;
	}

	if (comments.length === 0) {
		return <div>You haven't posted any comments yet.</div>;
	}

	if (!broadcastId) {
		return null;
	}

	return (
		<CSS.ViewerComments>
			{comments.map((comment) => {
				const authorShapedComment: AuthorComment = {
					id: comment.id,
					userId: currentUser.uid,
					userName: currentUser.name ?? currentUser.email ?? "You",
					text: comment.text,
					date: comment.date,
					read: true,
					sharedToFeed: comment.sharedToFeed,
					reply: comment.reply,
					repliedAt: comment.repliedAt,
				};

				return (
					<Card
						key={comment.id}
						borderColour={comment.sharedToFeed ? colours.yellow : undefined}
					>
						<Comment
							broadcastId={broadcastId}
							comment={authorShapedComment}
							status="shared"
							readOnly
							authorName={authorName}
						/>
					</Card>
				);
			})}
		</CSS.ViewerComments>
	);
};

export default ViewerComments;
